import { useState } from "react";
import AllSessions from "./AllSessions/AllSessions";
import AwaitingRefound from "./AwaitingRefound/AwaitingRefound";
import s from "./Sessions.module.css";

type TabValueType = "awaitRefund" | "allSessions";

const Sessions = () => {
  const [activeTab, setActiveTab] = useState<TabValueType>("awaitRefund");
  const allTabs: {
    value: TabValueType;
    label: string;
    component: JSX.Element;
  }[] = [
    {
      label: "Awaiting refund",
      value: "awaitRefund",
      component: <AwaitingRefound />,
    },
    {
      label: "All sessions",
      value: "allSessions",
      component: <AllSessions />,
    },
  ];
  return (
    <div className={s.container}>
      <div className={s.tabsBlock}>
        {allTabs.map((item, index) => (
          <div
            className={activeTab === item.value ? s.activeTab : s.notActiveTab}
            onClick={() => {
              setActiveTab(item.value);
            }}
            key={index}
          >
            <span>{item.label}</span>
            <span
              className={
                activeTab === item.value
                  ? s.tabActiveIndicator
                  : s.indicatorHidden
              }
            ></span>
          </div>
        ))}
      </div>
      <div className={s.contentBlock}>
        {allTabs.find((el) => el.value === activeTab)?.component}
      </div>
    </div>
  );
};

export default Sessions;
